import React from "react"
import styled from "styled-components"
import Link from "next/link"
import { inject, observer } from 'mobx-react'


const Container = styled.a`
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: #262626;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.75em;
  text-decoration: none;
`

const Name = styled.div`
  margin: 0 0 0 10px;
  color: #7f7f7f;
  :hover {
    text-decoration: underline;
  }
  ${props => props.theme.media.smallDesktop`
    margin: 10px 0 0 0;
  `};
`

@inject(all => ({
  isLoggedIn: all.store.auth.isLoggedIn,
  user: all.store.auth.user
}))
@observer
class UserAvatar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {name: props.user.firstName}
  }

  render() {
    if (!this.props.isLoggedIn) return <div />
    return (
      <Link href="/dashboard" passHref>
        <Container>
          <Name>{this.state.name.toUpperCase()}</Name>
        </Container>
      </Link>
    )
  }
}

export default UserAvatar
